import barba from '@barba/core';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export default class{

	constructor(){

        barba.hooks.afterOnce((data) => {
            this.init()
        });
        barba.hooks.beforeLeave((data) => {
            window.removeEventListener("resize",this.resize)
        });
        barba.hooks.after((data) => {
            this.init()
        });

    }

    init(){

        this.serviceFeature = false
        
        const serviceFeature = document.querySelector("#p-service")
        if(serviceFeature&&(window.innerWidth > 991)){
            this.serviceFeature = ScrollTrigger.create({
                trigger: ".p-service__feature--side",
                pin: ".p-service__feature--side",
                start: "center center",
                endTrigger: ".p-service__feature--main",
                end: "bottom bottom-=180px",
                // markers: true,
            });
        }
        this.resize()
        window.addEventListener("resize",this.resize.bind(this))


        this.serviceFlow = false
        
        const serviceFlow = document.querySelector("#p-service")
        if(serviceFlow&&(window.innerWidth > 991)){
            this.serviceFlow = ScrollTrigger.create({
                trigger: ".p-service__flow--side",
                pin: ".p-service__flow--side",
                start: "center center",
                endTrigger: ".p-service__flow--main",
                end: "bottom bottom-=180px",
                // markers: true,
            });
        }
        this.resize()
        window.addEventListener("resize",this.resize.bind(this))


        this.indexThoughts = false

        const indexThoughts = document.querySelector("#p-index__thoughts")
        if(indexThoughts&&(window.innerWidth > 991)){
            this.trigger = document.querySelector('.p-index__thoughts--img');
            this.elem = document.querySelectorAll('.p-index__thoughts--img--inner');
            if(this.elem) {
                this.elem.forEach((el, i) => {
                    gsap.to(el, {
                        x: '-25%',
                        scrollTrigger: {
                        trigger: this.trigger,
                        start: 'top 90%' ,
                        end: 'bottom -30%',  
                        scrub: 1,
                        //markers: true,
                        }
                    });
                })
            }
        }
        this.resize()
        window.addEventListener("resize",this.resize.bind(this))
    }
    resize(){
        if(window.innerWidth > 991){
            if(this.serviceFeature){
                this.serviceFeature.enable()
            }
            if(this.serviceFlow){
                this.serviceFlow.enable()
            }
            if(this.indexThoughts){
                this.indexThoughts.enable()
            }
        }else{
            if(this.serviceFeature){
                this.serviceFeature.disable()
            }
            if(this.serviceFlow){
                this.serviceFlow.disable()
            }
            if(this.indexThoughts){
                this.indexThoughts.disable()
            }
        }
    }
    // messageImgFix(){
    //     this.trigger = document.querySelector('.p-message__content');
    //     this.elem = document.querySelectorAll('.p-message__side');
    //     if(this.elem) {
    //         this.elem.forEach((el, i) => {
    //             gsap.to(el, {
    //                 scrollTrigger: {
    //                     trigger: this.trigger,
    //                     start: 'top center' ,
    //                     end: 'bottom top',  
    //                     scrub: 1, 
    //                     markers: true,
    //                     pin: true,
    //                 }
    //             });
    //         })
    //     }
    // }
    
}